import React from "react";
import { Navigate } from "react-router-dom";
import { CurrentUserContext } from '../../Contexts/CurrentUserContext';


const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = React.useContext(CurrentUserContext);
// console.log(isLoggedIn)
    if (!isLoggedIn) {
      return <Navigate to="/login" replace />;
    }
  
    return children;
  };

export default ProtectedRoute;